export class VirtualMachineRestoreDestination {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "vmName",
            "baseName": "vmName",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return VirtualMachineRestoreDestination.attributeTypeMap;
    }
    constructor() {
    }
}
